import {
  jb_anchor_css_default
} from "./chunk.E5Q2KX3Z.js";
import {
  Linkable
} from "./chunk.MFPI4EPN.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-anchor/jb-anchor.ts
var JbAnchor = class extends Linkable(r) {
  constructor() {
    super(...arguments);
    this.flyPadding = "";
    this.forceHover = false;
    this.inactive = false;
  }
  render() {
    const classes = {
      inactive: !!this.inactive,
      hover: !!this.forceHover
    };
    return ke`<a
      data-linkable
      class="${Rt(classes)}"
      .tabIndex=${this.inactive ? -1 : 0}
      part="anchor"
      data-fly-padding="${this.flyPadding ?? D}"
      aria-label="${this.ariaLabels?.label ?? D}"
      ><slot></slot
    ></a>`;
  }
};
JbAnchor.styles = [reset_css_default, jb_anchor_css_default];
__decorateClass([
  n({ type: Object })
], JbAnchor.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbAnchor.prototype, "flyPadding", 2);
__decorateClass([
  n({ type: Boolean })
], JbAnchor.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbAnchor.prototype, "inactive", 2);
JbAnchor = __decorateClass([
  customElement("jb-anchor")
], JbAnchor);

export {
  JbAnchor
};
